'use strict';

angular.module('shiftTraderApp')
    .controller('OrganizationEndTrialCtrl', function ($scope, $uibModalInstance, regexStrings,
                                                          $state, OrganizationSettings, $interval,
                                                          $timeout, ServerUrls, Session, LibraryStore,
                                                          Registration, security, Angularytics,
                                                          SubscriptionPlansService, validCouponCodes,
                                                          InternalAnalyticsService, ReferralActions) {

      // we need the StripeJS API now :-)
      LibraryStore.load('stripejs')
        .then(function() {
          Stripe.setPublishableKey(ServerUrls.current.stripeToken);
        }, function() {

        });

      Session.generateNewSessionIdIfNotSet();
      $scope.modalInstance = $uibModalInstance;
      $scope.regexStrings = regexStrings;

      var detectTemplateLoadedInterval;
      var animationDuration = 400;

      $scope.sections = {
        trial: {
          formData: {
            numEmployees: 17,
            couponCode: ''
          },
          state: {
            selectedPlanIdx: null,
            q: {}
          }
        },
        payment: {
          formData: {},
          state: {},
          stripeData: undefined
        },
        finish: {
          formData: {},
          state: {
            inTrial: false
          }
        }
      };

      $scope.sectionTitles = [
        {
          name: 'Select Plan',
          machineName: 'trial'
        },
        {
          name: 'Payment Info',
          machineName: 'payment'
        },
        {
          name: 'Finish',
          machineName: 'finish'
        }
      ];

      Session.getCurrentOrg()
        .then(function(org) {
          $scope.org = org;
          $scope.sections.finish.state.inTrial = $scope.org.$isInTrialMode();
        }, function(response) {
          console.log('Failed to get current organization', response);
        });

      $scope.filterPlans = function() {
        // If the box is empty, assume the lowest plan
        if ($scope.sections.trial.formData.numEmployees === '' || parseInt($scope.sections.trial.formData.numEmployees) == 0) {
          $scope.sections.trial.basic = lodash.find($scope.sections.trial.allPlans, function(plan) {
            return plan.id === 'SA-BASIC';
          });
          $scope.sections.trial.team = lodash.find($scope.sections.trial.allPlans, function(plan) {
            return (plan.plan_type === 'TEAM' && plan.interval === 'month') &&
                   lodash.inRange(1, plan.num_emp_start, plan.num_emp_end + 1);
          });
          $scope.sections.trial.plus = lodash.find($scope.sections.trial.allPlans, function(plan) {
            return (plan.plan_type === 'PLUS' && plan.interval === 'month') &&
                   lodash.inRange(1, plan.num_emp_start, plan.num_emp_end + 1);
          });
          $scope.sections.trial.callus = false;
        } else if (parseInt($scope.sections.trial.formData.numEmployees) > 199) {
          $scope.sections.trial.basic = lodash.find($scope.sections.trial.allPlans, function(plan) {
            return plan.id === 'SA-BASIC';
          });
          $scope.sections.trial.team = lodash.find($scope.sections.trial.allPlans, function(plan) {
            return (plan.plan_type === 'TEAM' && plan.interval === 'month') &&
                   lodash.inRange(199, plan.num_emp_start, plan.num_emp_end + 1);
          });
          $scope.sections.trial.plus = lodash.find($scope.sections.trial.allPlans, function(plan) {
            return (plan.plan_type === 'PLUS' && plan.interval === 'month') &&
                   lodash.inRange(199, plan.num_emp_start, plan.num_emp_end + 1);
          });
          $scope.sections.trial.callus = true;
        } else {
          // Show them the plans based on the number they entered for their employee number
          $scope.sections.trial.basic = lodash.find($scope.sections.trial.allPlans, function(plan) {
            return plan.id === 'SA-BASIC';
          });
          $scope.sections.trial.team = lodash.find($scope.sections.trial.allPlans, function(plan) {
            return (plan.plan_type === 'TEAM' && plan.interval === 'month') &&
                   lodash.inRange($scope.sections.trial.formData.numEmployees, plan.num_emp_start, plan.num_emp_end + 1);
          });
          $scope.sections.trial.plus = lodash.find($scope.sections.trial.allPlans, function(plan) {
            return (plan.plan_type === 'PLUS' && plan.interval === 'month') &&
                   lodash.inRange($scope.sections.trial.formData.numEmployees, plan.num_emp_start, plan.num_emp_end + 1);
          });
          $scope.sections.trial.callus = false;
        }
      };

      /**
       * Load the plans in from the YAML file
       */
      SubscriptionPlansService.getPlans('v3')
        .then(function(plans) {
          $scope.sections.trial.allPlans = plans;
          $scope.filterPlans();
        });

      $scope.preloadWizard = function(currentState) {
        // TODO: set these dynamically
        $scope.currentState = currentState;
        $scope.newState = currentState;

        detectTemplateLoadedInterval = $interval(function() {
          if( $('.modal_wizard_slide_wrapper').length > 0 ) {
            $scope.goToState($scope.currentState, true);
          }
        }, 10);
      };

      $scope.sections.trial.selectPlan = function(type) {
        $scope.sections.trial.state.selectedPlan = $scope.sections.trial[type];
        if (type === 'basic') {
          $scope.goToState(2);
        } else {
          $scope.goToNext();
        }
      };

      $scope.$watch('sections.payment.stripeData', function(newValue, oldValue) {
        if ($scope.sections.payment.stripeData && newValue != oldValue) {
          $scope.org.createCreditCard($scope.sections.payment.stripeData.id)
            .then(function(creditCard) {
              console.log('Added Credit Card', creditCard);
            }, function(response) {
              console.log('Failed to add Credit Card', response);
            });
        }
      });

      $scope.submit = function() {
        Session.getCurrentOrg(true)
          .then(function(org) {
            org.$updatePlan($scope.sections.trial.state.selectedPlan.plan_type, $scope.sections.trial.state.selectedPlan.id)
              .then(function() {
                Session.getCurrentOrg(true); // update the current org to include queued_plan
              }, function(response) {
              });
          }, function(response) {
          });

      };

      $scope.goToNext = function() {
        $scope.goToState($scope.currentState + 1);
        return true;
      };

      $scope.goToPrev = function() {
        $scope.goToState($scope.currentState - 1);
      };

      var transitionTimeout;
      var animationTimeout;

      $scope.goToState = function(newState, goNow) {
        $scope.newState = newState;

        if (!_.isUndefined(detectTemplateLoadedInterval)) {
          $interval.cancel(detectTemplateLoadedInterval);
          detectTemplateLoadedInterval = undefined;
        }

        // Wait for a small amount of time before animating to
        // allow the target slide directive to instantiate
        animationTimeout = $timeout(function () {
          if (!_.isUndefined(goNow)) { // If we loaded to a specific state, do not animate
            $('.modal_wizard_slide_wrapper').css({
              left: newState * -1000
            });
          } else { // If we clicked a button, animate
            $('.modal_wizard_slide_wrapper').animate({
                left: newState * -1000
              }, animationDuration);
          }
        }, 50);

        // Create transitioning timer so current slide doesn't
        // disappear at start of animation
        if (!_.isUndefined(transitionTimeout)) {
          $timeout.cancel(transitionTimeout);
        }
        transitionTimeout = $timeout(function () {
          $scope.currentState = newState;

          if ($scope.sections[$scope.sectionTitles[newState].machineName].onEnter) {
            $scope.sections[$scope.sectionTitles[newState].machineName].onEnter();
          }

        }, animationDuration);

        // InternalAnalyticsService.captureAnalytic('signupWizard:slideChange', {
        //   current_slide: $scope.currentState,
        //   new_slide: newState,
        //   first_name: $scope.sections.account.formData.firstName,
        //   last_name: $scope.sections.account.formData.lastName,
        //   email: $scope.sections.account.formData.email
        // });

        // Angularytics.trackEvent('Signup', 'signup-slide-change', $scope.sectionTitles[newState].machineName, newState);

      };

      $scope.close = function() {
        $uibModalInstance.close('close');
      };

      $scope.displaySlide = function(slide) {
        return $scope.currentState === slide || $scope.newState === slide;
      };

      $scope.wizardComplete = function() {
        $state.go('manageWorkPeriods.date');

        $timeout(function() {
          $uibModalInstance.close('finished wizard');
        }, 1000);
      };

      $scope.preloadWizard(0);

    });
